"use client";
import { jsx as s } from "react/jsx-runtime";
import { EmbeddedChatPrimitive as a, composeRefs as w, useResizeObserver as M } from "@inkeep/cxkit-primitives";
import { aiChatPageWrapper as y } from "../ui/recipes/ai-chat-page-wrapper.js";
import { attachment as l } from "../ui/recipes/attachment.js";
import { button as d } from "../ui/recipes/button.js";
import { checkbox as p } from "../ui/recipes/checkbox.js";
import { citation as m } from "../ui/recipes/citation.js";
import { icon as N } from "../ui/recipes/icon.js";
import { input as c } from "../ui/recipes/input.js";
import { link as I } from "../ui/recipes/link.js";
import { modal as o } from "../ui/recipes/modal.js";
import { popover as b } from "../ui/recipes/popover.js";
import { scrollable as g } from "../ui/recipes/scrollable.js";
import { select as i } from "../ui/recipes/select.js";
import { cva as B } from "class-variance-authority";
import { merge as v } from "merge-anything";
import { forwardRef as u, useRef as S } from "react";
import { cn as r } from "../utils.js";
import { markdownStyles as T } from "../ui/markdown-styles.js";
import { LoadingIndicator as H } from "./loading-indicator.js";
import { ConversationLoading as L } from "./embedded-chat/conversation-loading.js";
const ae = a.Provider, se = u(
  ({ className: e, size: t, variant: n, ...x }, h) => /* @__PURE__ */ s(
    a.Wrapper,
    {
      ref: h,
      className: r(
        y({ size: t, variant: n }),
        "data-[hidden]:hidden rounded-md flex",
        "bg-white dark:bg-gray-dark-950",
        "data-[composite]:w-full",
        "max-h-[min(85vh,850px)]",
        e
      ),
      ...x
    }
  )
), re = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  a.ConversationLoading,
  {
    className: r("flex flex-col items-center justify-center h-full gap-12 flex-1 p-8", e),
    children: /* @__PURE__ */ s(L, {}),
    ...t
  }
), oe = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  a.Root,
  {
    className: r(g({ section: "wrapper" }), "rounded-[inherit] font-body", e),
    ...t
  }
), de = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  a.Header,
  {
    className: r(
      g({ section: "header" }),
      "flex items-center",
      "bg-white dark:bg-gray-dark-950",
      "data-[show-toolbar]:after:absolute",
      "data-[show-toolbar]:after:left-0",
      "data-[show-toolbar]:after:top-full",
      "data-[show-toolbar]:after:h-[1rem]",
      "data-[show-toolbar]:after:w-full",
      "data-[show-toolbar]:after:text-white",
      "data-[show-toolbar]:after:dark:text-gray-dark-950",
      "data-[show-toolbar]:after:bg-[linear-gradient(currentColor,_transparent)]",
      "data-[show-toolbar]:after:z-start",
      e
    ),
    ...t
  }
), ne = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  a.HeaderToolbar,
  {
    className: r(
      "flex items-center gap-2 w-full pl-6 pr-1",
      "ikp-md:px-4 py-2 justify-between *:m-0",
      e
    ),
    ...t
  }
), me = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  a.HeaderToolbarWrapper,
  {
    className: r("flex items-center gap-1.5", e),
    ...t
  }
), le = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  a.ToolbarHeader,
  {
    className: r("text-gray-600 dark:text-gray-dark-100 text-sm", e),
    ...t
  }
), ce = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  a.Content,
  {
    className: r(g({ section: "content" }), "justify-end", e),
    ...t
  }
), ie = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  a.ContentScrollArea,
  {
    className: r("overflow-hidden", e),
    ...t
  }
), he = u(({ className: e, ...t }, n) => /* @__PURE__ */ s(
  a.ContentScrollAreaViewport,
  {
    ref: n,
    className: r("h-full w-full rounded-[inherit]", e),
    ...t
  }
)), pe = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  a.ContentScrollAreaScrollbar,
  {
    className: r(
      "flex select-none touch-none p-0.5",
      "transition-colors duration-[160ms] ease-in-out",
      "w-2.5 border-l border-l-transparent",
      e
    ),
    ...t
  }
), be = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  a.ContentScrollAreaThumb,
  {
    className: r("relative flex-1 rounded-full", "bg-gray-300 dark:bg-white-alpha-200", e),
    ...t
  }
), ge = a.ContentScrollAreaCorner, ue = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  a.Disclaimer,
  {
    className: r("ml-auto text-sm flex items-center gap-1", e),
    ...t
  }
), xe = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  a.DisclaimerLabel,
  {
    className: r("text-gray-700 dark:text-gray-dark-100", e),
    ...t
  }
), fe = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  a.DisclaimerTrigger,
  {
    className: r("cursor-pointer text-gray-700 dark:text-gray-dark-100", e),
    ...t
  }
), Ce = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  a.DisclaimerContent,
  {
    className: r(
      b({ slot: "content" }),
      "px-4 py-2 font-normal",
      "w-[250px] sm:w-[420px]",
      e
    ),
    ...t
  }
), Fe = a.DisclaimerText, Ae = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  a.DisclaimerArrow,
  {
    className: r(b({ slot: "arrow" }), e),
    ...t
  }
), ke = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  a.ExampleQuestions,
  {
    className: r("mt-4 flex flex-col gap-2", e),
    ...t
  }
), Ee = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  a.ExampleQuestionsLabel,
  {
    className: r(
      "text-2xs uppercase font-semibold tracking-widest",
      "text-gray-600 dark:text-white-alpha-500",
      e
    ),
    ...t
  }
), we = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  a.ExampleQuestionsList,
  {
    className: r("flex flex-col", "ikp-md:flex-row", "flex-wrap gap-2", e),
    ...t
  }
), Me = u(({ className: e, style: t, ...n }, x) => {
  const h = S(null), F = w(x, h), { width: A = 0, height: k = 0 } = M({
    ref: h,
    box: "border-box"
  }), E = Math.max(k, A);
  return /* @__PURE__ */ s(
    a.ExampleQuestion,
    {
      ref: F,
      style: {
        "--before-size": `${E + 100}px`,
        ...t
      },
      className: r(
        "flex items-center justify-center relative z-base",
        "min-h-9 rounded-md overflow-hidden",
        "before:absolute before:z-hide",
        "before:bg-gray-300 dark:before:bg-gray-dark-950",
        "before:bg-no-repeat before:[background-position:0_0]",
        "before:[background-size:cover] before:m-auto",
        "before:w-[--before-size] before:h-[--before-size]",
        "data-[highlight]:first:before:[background-image:conic-gradient(transparent,theme(colors.inkeep-expanded-primary.600),transparent_30%)]",
        "dark:data-[highlight]:first:before:[background-image:conic-gradient(transparent,theme(colors.inkeep-expanded-primary.300),transparent_30%)]",
        "data-[highlight]:first:before:animate-[spin_4s_linear_infinite]",
        "after:absolute after:z-base after:top-[1px] after:left-[1px]",
        "after:w-[calc(100%-2px)] after:h-[calc(100%-2px)]",
        "after:rounded-[5px] after:bg-white dark:after:bg-gray-dark-950",
        e
      ),
      ...n
    }
  );
}), ye = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  a.ExampleQuestionButton,
  {
    className: r(
      d({ size: "sm" }),
      "text-sm font-normal h-auto w-full py-2 z-start",
      "whitespace-normal text-center leading-[unset]",
      "border border-solid",
      "text-gray-800 dark:text-white-alpha-950",
      "border-white-alpha-200",
      "[&:where(:hover,:focus)]:bg-slate-400/5",
      "dark:[&:where(:hover,:focus)]:bg-white-alpha-100 focus:z-start",
      e
    ),
    ...t
  }
), Ne = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  a.Workflows,
  {
    className: r("mt-4 flex flex-col gap-2", e),
    ...t
  }
), Ie = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  a.WorkflowsLabel,
  {
    className: r(
      "text-2xs uppercase font-semibold tracking-widest",
      "text-gray-600 dark:text-white-alpha-500",
      e
    ),
    ...t
  }
), Be = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  a.WorkflowsList,
  {
    className: r("flex flex-wrap gap-2", e),
    ...t
  }
), ve = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  a.Workflow,
  {
    className: r(
      d({ size: "sm" }),
      "min-h-9 px-3 py-2 h-auto font-medium",
      "text-sm gap-2 whitespace-normal border ",
      "text-inkeep-primary-strong dark:text-inkeep-expanded-primary-300",
      "border-inkeep-expanded-primary-200",
      "dark:border-inkeep-expanded-primary-200",
      "hover:bg-inkeep-primary-light-subtle",
      "dark:hover:bg-white-alpha-100",
      e
    ),
    ...t
  }
), Se = a.WorkflowIcon, Te = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  a.Messages,
  {
    className: r("flex flex-col w-full min-w-0 min-h-0 text-2sm relative", e),
    ...t
  }
), C = B([
  "flex relative w-full overflow-hidden py-8",
  "px-6 ikp-md:px-8",
  "flex-col ikp-md:flex-row",
  "min-w-0 grow-[2] data-[role=user]:grow-0",
  // Divider
  "[&:not(:last-child)]:after:absolute",
  "[&:not(:last-child)]:after:border-b",
  "[&:not(:last-child)]:after:bottom-0",
  "[&:not(:last-child)]:after:inset-x-6",
  "ikp-md:[&:not(:last-child)]:after:inset-x-8"
]), He = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(a.MessageWrapper, { className: r(C(), e), ...t }), Le = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  a.IntroMessageWrapper,
  {
    className: r(C(), e),
    ...t
  }
), De = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  a.MessageHeader,
  {
    className: r(
      "flex justify-start overflow-hidden shrink-0 select-none",
      "flex-row ikp-md:flex-col",
      "items-center ikp-md:items-start",
      "ikp-md:pl-3",
      "ikp-md:pr-6",
      "mb-6 ikp-md:mb-0",
      e
    ),
    ...t
  }
), We = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  a.MessageLoading,
  {
    className: r("flex items-center gap-3 h-12 w-full", e),
    children: /* @__PURE__ */ s(H, {}),
    ...t
  }
), ze = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  a.MessageAvatar,
  {
    className: r("flex items-center justify-center rounded-full", "h-auto ikp-md:h-12", e),
    ...t
  }
), Pe = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  a.MessageAvatarContent,
  {
    className: r(
      "relative flex h-8 w-8 shrink-0 overflow-hidden",
      "data-[username]:bg-inkeep-primary-lighter",
      "dark:data-[username]:bg-inkeep-expanded-primary-300",
      "text-inkeep-primary-stronger font-semibold ",
      "data-[role=user]:hidden ikp-md:flex",
      "justify-center items-center",
      e
    ),
    ...t
  }
), _e = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  a.MessageAvatarFallback,
  {
    className: r("hidden data-[role=user]:block", e),
    ...t
  }
), je = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  a.MessageAvatarImage,
  {
    className: r(
      "data-[type=icon]:data-[role=user]:text-inkeep-primary-medium",
      "dark:data-[type=icon]:data-[role=user]:text-inkeep-expanded-primary-300",
      "data-[type=icon]:data-[role=assistant]:[--start-color:theme(colors.inkeep-expanded-primary.300)]",
      "data-[type=icon]:data-[role=assistant]:[--end-color:theme(colors.inkeep-expanded-primary.700)]",
      "dark:data-[type=icon]:data-[role=assistant]:[--start-color:theme(colors.inkeep-expanded-primary.50)]",
      "dark:data-[type=icon]:data-[role=assistant]:[--end-color:theme(colors.inkeep-expanded-primary.300)]",
      e
    ),
    ...t
  }
), Qe = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  a.MessageName,
  {
    className: r(
      "px-3 py-1 ml-4 data-[role=user]:ml-0",
      "text-sm rounded-full",
      "bg-inkeep-primary-lighter data-[role=user]:bg-gray-50",
      "text-inkeep-primary-stronger dark:text-inkeep-expanded-primary-300",
      "data-[role=user]:text-gray-700 dark:data-[role=user]:text-white-alpha-700",
      "dark:bg-gray-dark-700",
      "ikp-md:hidden",
      e
    ),
    ...t
  }
), Oe = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  a.MessageContentWrapper,
  {
    className: r(
      "overflow-hidden flex flex-col",
      "justify-start grow-2 w-full",
      "data-[role=user]:justify-end",
      "data-[role=user]:shrink-2",
      "data-[role=user]:grow-0",
      "ikp-md:pr-3",
      e
    ),
    ...t
  }
), Ve = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  a.MessageContent,
  {
    className: r("text-2sm flex-wrap break-words min-w-0 shrink-1 max-w-full", e),
    ...t
  }
), Re = a.MessageAttachments, qe = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  a.MessageAttachmentsList,
  {
    className: r("flex flex-wrap gap-2", e),
    ...t
  }
), Ge = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  a.MessageAttachmentsItem,
  {
    className: r(
      d({ variant: "ghost" }),
      l({ slot: "root" }),
      "font-normal px-2",
      e
    ),
    ...t
  }
), $e = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  a.MessageAttachmentsItemIcon,
  {
    className: r(l({ slot: "icon" }), e),
    ...t
  }
), Je = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  a.MessageAttachmentsItemTitle,
  {
    className: r(l({ slot: "title" }), e),
    ...t
  }
), Ke = a.MessageAttachmentsPreview, Ue = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  a.MessageAttachmentsPreviewOverlay,
  {
    className: r(o({ slot: "overlay" }), e),
    ...t
  }
), Xe = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  a.MessageAttachmentsPreviewContent,
  {
    className: r(
      o({ slot: "content" }),
      "my-6 md:my-12 top-0 left-[unset] transform-none relative",
      "p-8 md:p-10 max-w-2xl",
      e
    ),
    ...t
  }
), Ye = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  a.MessageAttachmentsPreviewHeader,
  {
    className: r(
      o({ slot: "header" }),
      "px-0 pt-0 pb-8 flex flex-col gap-6",
      "font-semibold",
      e
    ),
    ...t
  }
), Ze = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  a.MessageAttachmentsPreviewClose,
  {
    className: r(o({ slot: "close" }), e),
    ...t
  }
), et = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  a.MessageAttachmentsPreviewBody,
  {
    className: r(o({ slot: "body" }), "p-0", e),
    ...t
  }
), tt = ({
  className: e,
  componentStyles: t,
  ...n
}) => /* @__PURE__ */ s(
  a.Message,
  {
    className: r("data-[role=user]:whitespace-pre-wrap mb-3 max-w-full", e),
    componentStyles: v(T, t ?? {}),
    ...n
  }
), at = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  a.MessageToolbar,
  {
    className: r("flex items-center mt-2 mb-3", e),
    ...t
  }
), st = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  a.MessageToolActions,
  {
    className: r("mr-auto flex items-center gap-2", e),
    ...t
  }
), rt = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  a.MessageToolAction,
  {
    className: r(
      d({ size: "xs", variant: "outline" }),
      "text-xs h-[30px] text-gray-700 dark:text-gray-200 gap-1",
      e
    ),
    ...t
  }
), ot = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  a.MessageAction,
  {
    className: r(
      d({ variant: "iconButton", size: "sm" }),
      "data-[upvoted]:text-inkeep-primary-medium",
      "data-[downvoted]:text-inkeep-primary-medium",
      "data-[upvoted]:dark:text-inkeep-expanded-primary-300",
      "data-[downvoted]:dark:text-inkeep-expanded-primary-300",
      "dark:hover:text-inkeep-expanded-primary-300 px-2 text-md",
      e
    ),
    ...t
  }
), dt = a.MessageSources, nt = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  a.MessageSourcesHeader,
  {
    className: r(
      "block text-xs font-medium my-2 text-gray-700 dark:text-gray-dark-300",
      e
    ),
    ...t
  }
), mt = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  a.MessageSourcesList,
  {
    className: r("w-full relative flex flex-col gap-3 py-[1px]", e),
    ...t
  }
), lt = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  a.MessageSourceItem,
  {
    className: r(m({ slot: "root" }), e),
    ...t
  }
), ct = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  a.MessageSourceItemBreadcrumbs,
  {
    className: r(m({ slot: "breadcrumbs" }), e),
    ...t
  }
), it = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  a.MessageSourceItemBreadcrumbIcon,
  {
    className: r(m({ slot: "breadcrumbsIcon" }), e),
    ...t
  }
), ht = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  a.MessageSourceItemIcon,
  {
    className: r(m({ slot: "icon" }), e),
    ...t
  }
), pt = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  a.MessageSourceItemTitle,
  {
    className: r(m({ slot: "title" }), e),
    ...t
  }
), bt = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  a.MessageSourceItemTag,
  {
    className: r(m({ slot: "tag" }), e),
    ...t
  }
), gt = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  a.MessageSourceItemDescription,
  {
    className: r(m({ slot: "description" }), e),
    ...t
  }
), ut = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  a.MessageSourceItemDescriptionPart,
  {
    className: r(m({ slot: "descriptionPart" }), e),
    ...t
  }
), xt = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  a.MessageSourceItemIndicator,
  {
    className: r(m({ slot: "indicator" }), e),
    ...t
  }
), ft = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  a.Footer,
  {
    className: r(
      "bg-white dark:bg-gray-dark-950 pt-6 pb-4",
      "px-6 ikp-md:px-8 relative",
      "before:absolute before:block before:top-0 before:left-0",
      "before:pointer-events-none before:w-full before:h-3",
      "before:bg-gradient-to-b before:from-transparent before:to-white",
      "dark:before:to-gray-dark-950 before:-translate-y-full",
      e
    ),
    ...t
  }
), Ct = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  a.InputFieldset,
  {
    className: r(
      "relative flex flex-col w-full p-2",
      "rounded-lg items-stretch shadow-md dark:shadow-none",
      "bg-gray-50 dark:bg-white-alpha-50",
      e
    ),
    ...t
  }
), Ft = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(a.InputGroup, { className: r("flex", e), ...t }), At = u(({ className: e, ...t }, n) => /* @__PURE__ */ s(
  a.Input,
  {
    ref: n,
    className: r(
      "min-h-[unset] overflow-hidden w-full resize-none",
      "placeholder:text-gray-500 dark:placeholder:text-gray-dark-200",
      "border-none outline-none shadow-none bg-transparent",
      "px-3 py-2 ml-1 mr-2 max-h-[200px] overflow-y-auto disabled:cursor-not-allowed",
      e
    ),
    ...t
  }
)), kt = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  a.SendButton,
  {
    className: r(
      d({}),
      "bg-transparent relative size-10 rounded-lg transition-all ease-linear",
      "text-inkeep-primary-medium dark:text-inkeep-expanded-primary-500",
      "active:bg-gray-300 dark:active:bg-white-alpha-100",
      "hover:bg-gray-200 hover:text-inkeep-primary-strong",
      "dark:hover:bg-white-alpha-100 dark:hover:text-inkeep-expanded-primary-300",
      "disabled:text-gray-500 dark:disabled:text-white-alpha-200",
      "disabled:cursor-not-allowed hover:disabled:[background:none] active:disabled:[background:none]",
      e
    ),
    ...t
  }
), Et = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  a.SendButtonIcon,
  {
    className: r(N(), "text-inherit rotate-[-30deg]", e),
    ...t
  }
), wt = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  a.AttachmentsBar,
  {
    className: r(
      "flex items-center justify-between",
      "flex-wrap gap-2 px-1 pt-2 pb-1",
      e
    ),
    ...t
  }
), Mt = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  a.AttachmentsBarList,
  {
    className: r("flex items-center gap-2 flex-wrap px-3 min-w-0", e),
    ...t
  }
), yt = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  a.AttachmentsBarAttachment,
  {
    className: r(l({ slot: "root" }), e),
    ...t
  }
), Nt = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  a.AttachmentsBarAttachmentIcon,
  {
    className: r(l({ slot: "icon" }), e),
    ...t
  }
), It = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  a.AttachmentsBarAttachmentTitle,
  {
    className: r(l({ slot: "title" }), e),
    ...t
  }
), Bt = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  a.AttachmentsBarAttachmentDelete,
  {
    className: r(l({ slot: "delete" }), e),
    ...t
  }
), vt = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  a.AttachmentsBarActions,
  {
    className: r("flex items-center justify-between", "gap-2 flex-wrap px-3", e),
    ...t
  }
), St = a.AttachmentsBarInfoTip, Tt = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  a.AttachmentsBarInfoTipIcon,
  {
    className: r("cursor-pointer text-sm text-gray-600", "dark:text-white-alpha-600", e),
    ...t
  }
), Ht = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  a.AttachmentsBarInfoTipText,
  {
    className: r(
      "bg-white text-gray-800 fill-white",
      "dark:bg-gray-dark-800 dark:text-white-alpha-950 dark:fill-gray-dark-800",
      "shadow-[0_8px_30px_rgba(0,0,0,0.12)] z-dropdown",
      "px-3 py-2 rounded-md text-sm font-normal max-w-[200px]",
      e
    ),
    ...t
  }
), Lt = a.AttachmentsBarInfoTipArrow, Dt = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(a.AttachmentsBarInputs, { className: r("contents", e), ...t }), Wt = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  a.AttachmentsBarInput,
  {
    className: r(
      d({ variant: "outline", size: "xs" }),
      "light:text-gray-700 gap-1",
      e
    ),
    ...t
  }
), zt = a.AttachmentsBarInputIcon, Pt = a.AttachmentsBarModal, _t = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  a.AttachmentsBarModalOverlay,
  {
    className: r(o({ slot: "overlay" }), e),
    ...t
  }
), jt = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  a.AttachmentsBarModalContent,
  {
    className: r(
      o({ slot: "content" }),
      "my-6 md:my-12 top-0 left-[unset] transform-none relative",
      "p-8 md:p-10 max-w-2xl",
      e
    ),
    ...t
  }
), Qt = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  a.AttachmentsBarModalHeader,
  {
    className: r(o({ slot: "header" }), "px-0 pt-0 pb-8 gap-y-2", "font-semibold", e),
    ...t
  }
), Ot = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  a.AttachmentsBarModalHeading,
  {
    className: r("w-full semibold", e),
    ...t
  }
), Vt = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  a.AttachmentsBarModalDescription,
  {
    className: r(
      "text-gray-700 dark:text-white-alpha-700",
      "text-sm font-normal w-full",
      e
    ),
    ...t
  }
), Rt = a.AttachmentsBarModalHelp, qt = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  a.AttachmentsBarModalClose,
  {
    className: r(o({ slot: "close" }), e),
    ...t
  }
), Gt = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  a.AttachmentsBarModalBody,
  {
    className: r(o({ slot: "body" }), "p-0", e),
    ...t
  }
), $t = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  a.AttachmentsBarForm,
  {
    className: r("flex flex-col gap-8", e),
    ...t
  }
), Jt = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  a.AttachmentsBarFormTitle,
  {
    className: r("flex flex-col gap-2", e),
    ...t
  }
), Kt = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  a.AttachmentsBarFormTitleLabel,
  {
    className: r("text-sm font-medium text-gray-700 dark:text-white-alpha-700", e),
    ...t
  }
), Ut = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  a.AttachmentsBarFormTitleInput,
  {
    className: r(
      "h-10 px-4 rounded-md border",
      "focus:outline-none focus:[--shadow-color:theme(colors.blue.500)]",
      "data-[invalid]:[--shadow-color:theme(colors.red.500)]",
      "shadow-[0_0_0_2px_var(--shadow-color)]",
      e
    ),
    ...t
  }
), Xt = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  a.AttachmentsBarFormTitleError,
  {
    className: r("text-sm text-red-500", e),
    ...t
  }
), Yt = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  a.AttachmentsBarFormContent,
  {
    className: r("flex flex-col gap-2", e),
    ...t
  }
), Zt = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  a.AttachmentsBarFormContentLabel,
  {
    className: r("text-sm font-medium text-gray-700 dark:text-white-alpha-700", e),
    ...t
  }
), ea = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  a.AttachmentsBarFormContentInput,
  {
    className: r(c({ size: "md", variant: "outline" }), "min-h-20 px-4 py-2", e),
    ...t
  }
), ta = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  a.AttachmentsBarFormContentError,
  {
    className: r("text-sm text-red-500", e),
    ...t
  }
), aa = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  a.AttachmentsBarFormSubmitButton,
  {
    className: r(d({ preset: "neutralFilled" }), "ml-auto", e),
    ...t
  }
), sa = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  a.ActionBar,
  {
    className: r("mt-4 flex items-start justify-between flex-wrap-reverse gap-2.5", e),
    ...t
  }
), ra = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  a.Actions,
  {
    className: r("flex items-center gap-2.5 flex-wrap", e),
    ...t
  }
), oa = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  a.TaglineContainer,
  {
    className: r("flex items-center whitespace-nowrap", e),
    ...t
  }
), da = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  a.TaglineText,
  {
    className: r("text-xs md:text-sm text-gray-500 dark:text-white-alpha-600", e),
    ...t
  }
), na = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  a.TaglineLogo,
  {
    className: r("text-gray-400 dark:text-white-alpha-500", "w-[18px] ml-2 mr-1", e),
    ...t
  }
), ma = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  a.TaglineBrandName,
  {
    className: r(
      I(),
      "inline-flex text-xs md:text-sm text-gray-500",
      "dark:text-white-alpha-600 font-bold",
      e
    ),
    ...t
  }
), f = r(
  d({ size: "xs", variant: "outline" }),
  "text-gray-700 dark:text-white-alpha-700"
), la = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(a.ChatAction, { className: r(f, e), ...t }), ca = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(a.ChatActionLabel, { className: r("cursor-pointer", e), ...t }), ia = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  a.ChatActionFeedback,
  {
    className: r(
      "bg-white text-gray-800 fill-white",
      "dark:bg-gray-dark-800 dark:text-white-alpha-900 dark:fill-gray-dark-800",
      "shadow-[0_8px_30px_rgba(0,0,0,0.12)]",
      "px-2 py-3 rounded-md text-sm font-normal",
      e
    ),
    ...t
  }
), ha = a.HelpActions, pa = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(a.ChatHelpAction, { className: r(f, e), ...t }), ba = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  a.HelpActionsTrigger,
  {
    className: r(f, e),
    ...t
  }
), ga = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  a.HelpActionsMenu,
  {
    className: r(
      b({ slot: "content" }),
      "gap-3 px-3 py-4 ",
      "w-[254px] text-sm font-normal",
      e
    ),
    ...t
  }
), ua = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  a.HelpActionsMenuArrow,
  {
    className: r(b({ slot: "arrow" }), e),
    ...t
  }
), xa = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  a.HelpActionsMenuItem,
  {
    className: r("flex items-center cursor-pointer hover:underline", e),
    ...t
  }
), fa = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  a.HelpActionsMenuItemIcon,
  {
    className: r("mr-2 text-inkeep-primary-medium", e),
    ...t
  }
), Ca = a.FeedbackModal, Fa = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  a.FeedbackModalOverlay,
  {
    className: r(o({ slot: "overlay" }), e),
    ...t
  }
), Aa = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  a.FeedbackModalContent,
  {
    className: r(
      o({ slot: "content" }),
      "my-6 md:my-12 top-0 left-[unset] transform-none relative",
      "p-8 md:p-10 max-w-[480px]",
      e
    ),
    ...t
  }
), ka = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  a.FeedbackModalHeader,
  {
    className: r(o({ slot: "header" }), "px-0 pt-0 pb-8", "font-semibold", e),
    ...t
  }
), Ea = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  a.FeedbackModalClose,
  {
    className: r(o({ slot: "close" }), e),
    ...t
  }
), wa = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  a.FeedbackModalBody,
  {
    className: r(o({ slot: "body" }), "p-0", e),
    ...t
  }
), Ma = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(a.FeedbackForm, { className: r("flex flex-col gap-8", e), ...t }), ya = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  a.FeedbackItem,
  {
    className: r("flex flex-wrap items-center", "gap-[1rem_0.5rem]", e),
    ...t
  }
), Na = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  a.FeedbackItemCheckbox,
  {
    className: r(p({ slot: "root" }), e),
    ...t
  }
), Ia = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  a.FeedbackItemCheckboxIndicator,
  {
    className: r(p({ slot: "indicator" }), e),
    ...t
  }
), Ba = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  a.FeedbackItemLabel,
  {
    className: r(
      "select-none cursor-pointer font-medium text-sm",
      "text-gray-700 dark:text-white-alpha-700",
      e
    ),
    ...t
  }
), va = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  a.FeedbackItemDescription,
  {
    className: r("flex-[0_0_100%]", "min-h-20 py-2 border rounded-md", "px-4", e),
    ...t
  }
), Sa = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  a.FeedbackSubmitButton,
  {
    className: r(d({ preset: "neutralFilled" }), "ml-auto", e),
    ...t
  }
), Ta = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  a.FormWrapper,
  {
    className: r("w-full overflow-y-auto", e),
    ...t
  }
), Ha = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  a.Form,
  {
    className: r(
      g({ section: "content" }),
      "relative pt-4 pb-8 gap-8",
      "items-start justify-center w-full",
      "px-6 ikp-md:px-14 ikp-md:pb-14",
      e
    ),
    ...t
  }
), La = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  a.FormClose,
  {
    className: r(
      d({ variant: "ghost" }),
      "absolute right-1 top-1",
      "text-xl text-gray-500 dark:text-white-alpha-500 w-10 h-10 z-modal",
      e
    ),
    ...t
  }
), Da = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  a.FormHeader,
  {
    className: r("mt-12 flex flex-col gap-6", e),
    ...t
  }
), Wa = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  a.FormHeading,
  {
    className: r("font-semibold text-xl leading-5", e),
    ...t
  }
), za = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  a.FormDescription,
  {
    className: r("text-gray-700 dark:text-white-alpha-700 text-sm", e),
    ...t
  }
), Pa = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(a.FormContent, { className: r("w-full", e), ...t }), _a = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  a.FormField,
  {
    className: r(
      "mb-8 flex flex-col gap-2 data-[hidden]:hidden",
      "data-[input-type=checkbox]:flex-row data-[input-type=checkbox]:items-center",
      e
    ),
    ...t
  }
), ja = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  a.FormFieldLabel,
  {
    className: r(
      "font-medium text-sm text-gray-700",
      "dark:text-white-alpha-700 ",
      "font-medium relative",
      "data-[required]:after:absolute",
      'data-[required]:after:[content:"*"]',
      "data-[required]:after:ml-1",
      "data-[required]:after:mt-0",
      "data-[required]:after:text-red-500",
      "dark:data-[required]:after:text-red-300",
      e
    ),
    ...t
  }
), Qa = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  a.FormFieldText,
  {
    className: r(c({ size: "md", variant: "outline" }), e),
    ...t
  }
), Oa = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  a.FormFieldEmail,
  {
    className: r(c({ size: "md", variant: "outline" }), e),
    ...t
  }
), Va = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  a.FormFieldFile,
  {
    className: r(
      c({ size: "md", variant: "outline" }),
      "text-sm pl-2 file:h-full file:cursor-pointer py-0",
      "file:bg-transparent file:border-none file:font-medium",
      "file:text-sm file:text-gray-700 dark:file:text-white-alpha-700",
      e
    ),
    ...t
  }
), Ra = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  a.FormFieldTextArea,
  {
    className: r(c({ size: "md", variant: "outline" }), "min-h-20 px-4 py-2", e),
    ...t
  }
), qa = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  a.FormFieldCheckbox,
  {
    className: r(p({ slot: "root" }), e),
    ...t
  }
), Ga = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  a.FormFieldCheckboxIndicator,
  {
    className: r(p({ slot: "indicator" }), e),
    ...t
  }
), $a = a.FormFieldSelect, Ja = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  a.FormFieldSelectTrigger,
  {
    className: r(i({ slot: "trigger" }), e),
    ...t
  }
), Ka = a.FormFieldSelectValue, Ua = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  a.FormFieldSelectIcon,
  {
    className: r("h-4 w-4 opacity-45", e),
    ...t
  }
), Xa = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  a.FormFieldSelectContent,
  {
    className: r(i({ slot: "content" }), e),
    ...t
  }
), Ya = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  a.FormFieldSelectViewport,
  {
    className: r(i({ slot: "viewport" }), e),
    ...t
  }
), Za = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  a.FormFieldSelectItem,
  {
    className: r(i({ slot: "item" }), e),
    ...t
  }
), es = a.FormFieldSelectItemText, ts = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  a.FormFieldSelectItemIndicator,
  {
    className: r(i({ slot: "itemIndicator" }), e),
    ...t
  }
), as = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  a.FormFieldError,
  {
    className: r("text-sm flex items-center text-red-500 dark:text-red-300", e),
    ...t
  }
), ss = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  a.FormError,
  {
    className: r("text-red-500 dark:text-red-300", e),
    ...t
  }
), rs = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  a.FormFooter,
  {
    className: r("flex items-center justify-end gap-6 w-full", e),
    ...t
  }
), os = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  a.FormCancel,
  {
    className: r(d({ variant: "outline" }), e),
    ...t
  }
), ds = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  a.FormSubmit,
  {
    className: r(d({ preset: "neutralFilled" }), e),
    ...t
  }
), ns = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  a.FormSuccess,
  {
    className: r(
      "flex flex-col items-center justify-center h-auto",
      "m-auto px-6 py-8 ikp-md:py-14 ikp-md:px-14",
      e
    ),
    ...t
  }
), ms = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  a.FormSuccessHeading,
  {
    className: r(
      "mb-6 font-bold tracking-tight",
      "text-3xl md:text-4xl leading-6 md:leading-5",
      e
    ),
    ...t
  }
), ls = a.FormSuccessMessage, cs = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  a.FormSuccessButton,
  {
    className: r(d({ preset: "neutralFilled" }), "w-full mt-12 gap-2 shrink-0", e),
    ...t
  }
);
export {
  sa as ActionBar,
  ra as Actions,
  wt as AttachmentsBar,
  vt as AttachmentsBarActions,
  yt as AttachmentsBarAttachment,
  Bt as AttachmentsBarAttachmentDelete,
  Nt as AttachmentsBarAttachmentIcon,
  It as AttachmentsBarAttachmentTitle,
  $t as AttachmentsBarForm,
  Yt as AttachmentsBarFormContent,
  ta as AttachmentsBarFormContentError,
  ea as AttachmentsBarFormContentInput,
  Zt as AttachmentsBarFormContentLabel,
  aa as AttachmentsBarFormSubmitButton,
  Jt as AttachmentsBarFormTitle,
  Xt as AttachmentsBarFormTitleError,
  Ut as AttachmentsBarFormTitleInput,
  Kt as AttachmentsBarFormTitleLabel,
  St as AttachmentsBarInfoTip,
  Lt as AttachmentsBarInfoTipArrow,
  Tt as AttachmentsBarInfoTipIcon,
  Ht as AttachmentsBarInfoTipText,
  Wt as AttachmentsBarInput,
  zt as AttachmentsBarInputIcon,
  Dt as AttachmentsBarInputs,
  Mt as AttachmentsBarList,
  Pt as AttachmentsBarModal,
  Gt as AttachmentsBarModalBody,
  qt as AttachmentsBarModalClose,
  jt as AttachmentsBarModalContent,
  Vt as AttachmentsBarModalDescription,
  Qt as AttachmentsBarModalHeader,
  Ot as AttachmentsBarModalHeading,
  Rt as AttachmentsBarModalHelp,
  _t as AttachmentsBarModalOverlay,
  la as ChatAction,
  ia as ChatActionFeedback,
  ca as ChatActionLabel,
  ce as Content,
  ie as ContentScrollArea,
  ge as ContentScrollAreaCorner,
  pe as ContentScrollAreaScrollbar,
  be as ContentScrollAreaThumb,
  he as ContentScrollAreaViewport,
  re as ConversationLoading,
  ue as Disclaimer,
  Ae as DisclaimerArrow,
  Ce as DisclaimerContent,
  xe as DisclaimerLabel,
  Fe as DisclaimerText,
  fe as DisclaimerTrigger,
  Me as ExampleQuestion,
  ye as ExampleQuestionButton,
  ke as ExampleQuestions,
  Ee as ExampleQuestionsLabel,
  we as ExampleQuestionsList,
  Ma as FeedbackForm,
  ya as FeedbackItem,
  Na as FeedbackItemCheckbox,
  Ia as FeedbackItemCheckboxIndicator,
  va as FeedbackItemDescription,
  Ba as FeedbackItemLabel,
  Ca as FeedbackModal,
  wa as FeedbackModalBody,
  Ea as FeedbackModalClose,
  Aa as FeedbackModalContent,
  ka as FeedbackModalHeader,
  Fa as FeedbackModalOverlay,
  Sa as FeedbackSubmitButton,
  ft as Footer,
  Ha as Form,
  os as FormCancel,
  La as FormClose,
  Pa as FormContent,
  za as FormDescription,
  ss as FormError,
  _a as FormField,
  qa as FormFieldCheckbox,
  Ga as FormFieldCheckboxIndicator,
  Oa as FormFieldEmail,
  as as FormFieldError,
  Va as FormFieldFile,
  ja as FormFieldLabel,
  $a as FormFieldSelect,
  Xa as FormFieldSelectContent,
  Ua as FormFieldSelectIcon,
  Za as FormFieldSelectItem,
  ts as FormFieldSelectItemIndicator,
  es as FormFieldSelectItemText,
  Ja as FormFieldSelectTrigger,
  Ka as FormFieldSelectValue,
  Ya as FormFieldSelectViewport,
  Qa as FormFieldText,
  Ra as FormFieldTextArea,
  rs as FormFooter,
  Da as FormHeader,
  Wa as FormHeading,
  ds as FormSubmit,
  ns as FormSuccess,
  cs as FormSuccessButton,
  ms as FormSuccessHeading,
  ls as FormSuccessMessage,
  Ta as FormWrapper,
  de as Header,
  ne as HeaderToolbar,
  me as HeaderToolbarWrapper,
  pa as HelpAction,
  ha as HelpActions,
  ga as HelpActionsMenu,
  ua as HelpActionsMenuArrow,
  xa as HelpActionsMenuItem,
  fa as HelpActionsMenuItemIcon,
  ba as HelpActionsTrigger,
  At as Input,
  Ct as InputFieldset,
  Ft as InputGroup,
  Le as IntroMessageWrapper,
  tt as Message,
  ot as MessageAction,
  Re as MessageAttachments,
  Ge as MessageAttachmentsItem,
  $e as MessageAttachmentsItemIcon,
  Je as MessageAttachmentsItemTitle,
  qe as MessageAttachmentsList,
  Ke as MessageAttachmentsPreview,
  et as MessageAttachmentsPreviewBody,
  Ze as MessageAttachmentsPreviewClose,
  Xe as MessageAttachmentsPreviewContent,
  Ye as MessageAttachmentsPreviewHeader,
  Ue as MessageAttachmentsPreviewOverlay,
  ze as MessageAvatar,
  Pe as MessageAvatarContent,
  _e as MessageAvatarFallback,
  je as MessageAvatarImage,
  Ve as MessageContent,
  Oe as MessageContentWrapper,
  De as MessageHeader,
  We as MessageLoading,
  Qe as MessageName,
  lt as MessageSourceItem,
  it as MessageSourceItemBreadcrumbIcon,
  ct as MessageSourceItemBreadcrumbs,
  gt as MessageSourceItemDescription,
  ut as MessageSourceItemDescriptionPart,
  ht as MessageSourceItemIcon,
  xt as MessageSourceItemIndicator,
  bt as MessageSourceItemTag,
  pt as MessageSourceItemTitle,
  dt as MessageSources,
  nt as MessageSourcesHeader,
  mt as MessageSourcesList,
  rt as MessageToolAction,
  st as MessageToolActions,
  at as MessageToolbar,
  He as MessageWrapper,
  Te as Messages,
  ae as Provider,
  oe as Root,
  kt as SendButton,
  Et as SendButtonIcon,
  ma as TaglineBrandName,
  oa as TaglineContainer,
  na as TaglineLogo,
  da as TaglineText,
  le as ToolbarHeader,
  ve as Workflow,
  Se as WorkflowIcon,
  Ne as Workflows,
  Ie as WorkflowsLabel,
  Be as WorkflowsList,
  se as Wrapper
};
